// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MailChimp Integration Dashboard Styles
 * Modern, responsive styles for MailChimp integration dashboard
 */

.mailchimp-integration-dashboard {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.mailchimp-integration-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #EA580C, #FDBA74);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Tabs */
.dashboard-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 8px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.tab-button {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-button:hover {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
}

.tab-button.active {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Tab Content */
.tab-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Connection Section */
.connection-section {
  margin-bottom: 32px;
}

.connection-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.connection-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}


.connection-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.connection-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.connection-card.connected .connection-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.connection-card.disconnected .connection-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.connection-card.operational .connection-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.connection-card.error .connection-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.connection-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.connection-content h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.connection-content p {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.connection-detail {
  color: #4a5568;
  font-size: 0.8rem;
  font-weight: 400;
}

.connection-testing {
  font-size: 0.8rem;
  color: #EA580C;
  margin-top: 8px;
  display: block;
  font-weight: 500;
  animation: pulse 2s infinite;
}

.status-detail {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 4px;
  display: block;
  font-style: italic;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* Account Section */
.account-section {
  margin-bottom: 32px;
}

.account-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.account-info {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  min-width: 150px;
}

.info-value {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 400;
  text-align: right;
  word-break: break-all;
}

/* Statistics Section */
.statistics-section {
  margin-bottom: 32px;
}

.statistics-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card.synced .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.pending .stat-icon {
  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);
}

.stat-card.failed .stat-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.stat-card.subscribed .stat-icon {
  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);
}

.stat-card.unsubscribed .stat-icon {
  background: linear-gradient(135deg, #718096 0%, #4a5568 100%);
}

.stat-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-content h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Recent Syncs Section */
.recent-syncs-section {
  margin-bottom: 32px;
}

.recent-syncs-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.syncs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sync-item {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.1),
    0 1px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.sync-info {
  display: flex;
  gap: 12px;
  align-items: center;
}

.sync-organization {
  color: #2d3748;
  font-weight: 500;
}

.sync-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sync-status.synced {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.sync-status.pending {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.sync-status.failed {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

.sync-time {
  color: #4a5568;
  font-size: 0.9rem;
}

/* Failed Syncs Section */
.failed-syncs-section h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.failed-syncs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.failed-sync-item {
  background: rgba(229, 62, 62, 0.05);
  border: 1px solid rgba(229, 62, 62, 0.2);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.failed-sync-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.failed-sync-organization {
  color: #2d3748;
  font-weight: 500;
}

.failed-sync-error {
  color: #e53e3e;
  font-size: 0.9rem;
  font-style: italic;
}

.failed-sync-time {
  color: #4a5568;
  font-size: 0.9rem;
}

/* Empty States */
.no-syncs {
  text-align: center;
  padding: 40px;
  color: #4a5568;
}

/* Loading and Error States */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.error-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.error-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.error-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mailchimp-integration-dashboard {
    padding: 16px;
  }

  .mailchimp-integration-dashboard-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .dashboard-tabs {
    flex-direction: column;
  }

  .tab-button {
    text-align: center;
  }

  .stats-grid,
  .connection-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .sync-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .sync-info {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .mailchimp-integration-dashboard {
    padding: 12px;
  }

  .mailchimp-integration-dashboard-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .stats-grid,
  .connection-cards {
    grid-template-columns: 1fr;
  }

  .stat-card,
  .connection-card {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mailchimp/MailChimpIntegrationDashboard.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qDAAqD;EACrD,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;;AAGA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/**\n * MailChimp Integration Dashboard Styles\n * Modern, responsive styles for MailChimp integration dashboard\n */\n\n.mailchimp-integration-dashboard {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.mailchimp-integration-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, #EA580C, #FDBA74);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 8px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.tab-button:hover {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n}\n\n.tab-button.active {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n/* Tab Content */\n.tab-content {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Connection Section */\n.connection-section {\n  margin-bottom: 32px;\n}\n\n.connection-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.connection-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n\n.connection-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.connection-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.connection-card.connected .connection-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.connection-card.disconnected .connection-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.connection-card.operational .connection-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.connection-card.error .connection-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.connection-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.connection-content h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.connection-content p {\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 700;\n  margin: 0 0 4px 0;\n  line-height: 1.2;\n}\n\n.connection-detail {\n  color: #4a5568;\n  font-size: 0.8rem;\n  font-weight: 400;\n}\n\n.connection-testing {\n  font-size: 0.8rem;\n  color: #EA580C;\n  margin-top: 8px;\n  display: block;\n  font-weight: 500;\n  animation: pulse 2s infinite;\n}\n\n.status-detail {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 4px;\n  display: block;\n  font-style: italic;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Account Section */\n.account-section {\n  margin-bottom: 32px;\n}\n\n.account-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.account-info {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  min-width: 150px;\n}\n\n.info-value {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 400;\n  text-align: right;\n  word-break: break-all;\n}\n\n/* Statistics Section */\n.statistics-section {\n  margin-bottom: 32px;\n}\n\n.statistics-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card.synced .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.pending .stat-icon {\n  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);\n}\n\n.stat-card.failed .stat-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.stat-card.subscribed .stat-icon {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);\n}\n\n.stat-card.unsubscribed .stat-icon {\n  background: linear-gradient(135deg, #718096 0%, #4a5568 100%);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-content h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Recent Syncs Section */\n.recent-syncs-section {\n  margin-bottom: 32px;\n}\n\n.recent-syncs-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.syncs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sync-item {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.1),\n    0 1px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.sync-info {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.sync-organization {\n  color: #2d3748;\n  font-weight: 500;\n}\n\n.sync-status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.sync-status.synced {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.sync-status.pending {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.sync-status.failed {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n.sync-time {\n  color: #4a5568;\n  font-size: 0.9rem;\n}\n\n/* Failed Syncs Section */\n.failed-syncs-section h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.failed-syncs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.failed-sync-item {\n  background: rgba(229, 62, 62, 0.05);\n  border: 1px solid rgba(229, 62, 62, 0.2);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.failed-sync-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.failed-sync-organization {\n  color: #2d3748;\n  font-weight: 500;\n}\n\n.failed-sync-error {\n  color: #e53e3e;\n  font-size: 0.9rem;\n  font-style: italic;\n}\n\n.failed-sync-time {\n  color: #4a5568;\n  font-size: 0.9rem;\n}\n\n/* Empty States */\n.no-syncs {\n  text-align: center;\n  padding: 40px;\n  color: #4a5568;\n}\n\n/* Loading and Error States */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.error-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.error-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.error-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .mailchimp-integration-dashboard {\n    padding: 16px;\n  }\n\n  .mailchimp-integration-dashboard-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .dashboard-tabs {\n    flex-direction: column;\n  }\n\n  .tab-button {\n    text-align: center;\n  }\n\n  .stats-grid,\n  .connection-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .sync-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .sync-info {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .mailchimp-integration-dashboard {\n    padding: 12px;\n  }\n\n  .mailchimp-integration-dashboard-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .stats-grid,\n  .connection-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card,\n  .connection-card {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
